import { render, staticRenderFns } from "./ConfirmAccount.vue?vue&type=template&id=4006b646&"
import script from "./ConfirmAccount.vue?vue&type=script&lang=ts&"
export * from "./ConfirmAccount.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports